module.exports = __webpack_public_path__ + "img/seabid-logo.72d42f0a.png";